import { Edit } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import { useCheckUserPermission } from "../../common/userPermission";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

const BusinessCampaign = () => {
  // const navigate = useNavigate();
  const [datatlist, setDatatlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const user_data = useSelector((state) => state.user_data);
  const loginUserID = user_data?.id;

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [customerData, setCustomerData] = useState([])

  const route = all_routes;

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Business ID",
      accessorKey: "BusienssID",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //   header: "Customer Ids",
    //   accessorKey: "CustomerIds",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Content Data",
    //   accessorKey: "ContentData",
    //   enableSorting: true,
    // },
    {
      header: "Created At",
      accessorKey: "CreatedDate",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
        <span>{dateFormat(row.original.CreatedDate)}</span>
      ),
    },

    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
            // Proper column width control
      size: 150, // used by MRT/TanStack table for layout
      muiTableHeadCellProps: { sx: { minWidth: 100, maxWidth: 150 } },
      muiTableBodyCellProps: { sx: { minWidth: 100, maxWidth: 150 } },
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem", justifyContent:"center", alignItems:"center" }}>
          {useCheckUserPermission(route.customer) && (
            <button
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                getCampaignCustomers(row?.original?.ID)
                setSelectedRow(row.original); // store row data
                setShowModal(true);           // open modal
              }}
            >
              <Edit className="custome-icon-size" />
            </button>
          )}
        </Box>
      ),
    },
  ];

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/getcampaigndetail?BusinessID=${loginUserID}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      setDatatlist(response?.ResponseData?.Data);
    }
    setLoading(false);
  };

    const getCampaignCustomers = async (ID) => {
    setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: `Business/getCampaignCustomers`,
      payload: { ID: ID },
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response,"check customer data")
      setCustomerData((response?.ResponseData[0]))
    }
    setLoading(false);
  };


  useEffect(() => {
    prodcutDataListApi();
  }, []);

  return (
    <>
      <LoadingSpinner isLoading={loading} />

      <div className="page-wrapper">
        <div className="content">
          <HeaderModule refreshData={prodcutDataListApi} />

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={datatlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for showing ContentData */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Campaign Details</Modal.Title>
        </Modal.Header>

<Modal.Body>
  <div>
    <strong>Content Data:</strong>

    {/* Render Email Content */}
    <div
      style={{
        whiteSpace: "normal",
        marginTop: "12px",
        padding: "10px",
        background: "#f7f7f7",
        borderRadius: "6px",
        border: "1px solid #ddd",
      }}
      dangerouslySetInnerHTML={{
        __html: selectedRow?.ContentData || "<p>No Content Available</p>",
      }}
    />

    {/* Customer List Table */}
    <h5 className="mt-4 mb-2">Customer Details</h5>

    <table className="table table-bordered table-striped">
      <thead>
        <tr>
          <th>No</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        {customerData && customerData.length > 0 ? (
          customerData.map((el, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{el?.firstName || "-"}</td>
              <td>{el?.lastName || "-"}</td>
              <td>{el?.email || "-"}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="4" className="text-center">
              No Customer Records Found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</Modal.Body>


      </Modal>
    </>
  );
};

export default BusinessCampaign;
